// *disable-eslint*

/* eslint-disable */

(function ($, Drupal, drupalSettings, once) {
  'use strict';

  (function ($) {
    $.QueryString = (function (a) {
      if (a === "") return {};
      var b = {};
      for (var i = 0; i < a.length; ++i)
      {
        var p=a[i].split('=', 2);
        if (p.length != 2) continue;
        if (b[p[0]]) continue;
        b[p[0].replace('%5B', '[').replace('%5D', ']')] = decodeURIComponent(p[1].replace(/\+/g, " "));
      }
      return b;
    })(window.location.search.substr(1).split('&'));
  })(jQuery);

  Drupal.behaviors.tripPlannerFilters = {
    attach: function () {
      Drupal.behaviors.tripPlannerFilters.setCheckboxes();
      var triggerResubmission = false;
      var getparams = new Proxy(new URLSearchParams(window.location.search), {
        get: (searchParams, prop) => searchParams.get(prop),
      });
      var urlLocation = (getparams.location !== 'All') ? getparams.location : null;
      var urlLocationCity = getparams.location_city;
      var urlCat = (getparams.category !== 'All') ? getparams.category : null;

      // Validate that passed-in category is a real category.
      if (urlCat !== null && $('form.views-exposed-form select[name=category] option[value=' + urlCat + ']').length === 0) {
        // Update legacy values.
        switch (urlCat) {
          // Old Live-Music category.
          case 41:
          case '41':
            triggerResubmission = true;
            break;
        }

        // Unset passed-in category.
        urlCat = null;
      }

      var pfield_location_processed = null;
      var $pfield_location = $('.block-tnv-tripplanner-filters-form .form-item-location:not(.tp-processed)');
      if ($pfield_location.length > 0) {
        // Location psuedo field.
        pfield_location_processed = $pfield_location.addClass('tp-processed').pSelect({
          default: urlLocation,
          searchElement: $('.block-tnv-tripplanner-filters-form .form-item-city-search'),
          onChange: function (option) {
            var location_value = option.data('filterValue');
            var location_city = '';

            if (option.data('filterType') === 'cities') {
              // If city found via autocomplete, set location back to All.
              if (typeof location_value === 'number' || (typeof location_value === 'string' && location_value.startsWith('city-') === false)) {
                location_value = '';
                location_city = option.data('filterValue');
              }
            }

            // Set location values.
            $('form.views-exposed-form select[name=location]').val(location_value);
            $('form.views-exposed-form input[name=location_city]').val(location_city);

            // Submit form.
            Drupal.behaviors.tripPlannerFilters.filterSubmit();
          },
          onClear: function () {
            // Clear filters.
            $('form.views-exposed-form select[name=location]').val('All');
            $('form.views-exposed-form input[name=location_city]').val('');

            // Submit form.
            Drupal.behaviors.tripPlannerFilters.filterSubmit();
          }
        });
      }

      var pfield_cat_child_processed = null;
      var $pfield_cat_child = $('.block-tnv-tripplanner-filters-form .form-item-category-child:not(.tp-processed)');
      if ($pfield_cat_child.length > 0) {
        pfield_cat_child_processed = $pfield_cat_child.addClass('tp-processed').pSelect({
          default: urlCat,
          disabled: true,
          onChange: function (option) {
            $('form.views-exposed-form select[name=category]').val(option.data('filterValue'));
            // Submit form.
            Drupal.behaviors.tripPlannerFilters.filterSubmit();
          },
          onClear: function (plugin) {
            $('form.views-exposed-form select[name=category]').val(plugin.settings.optGroupId);
            // Submit form.
            Drupal.behaviors.tripPlannerFilters.filterSubmit();
          }
        });
      }

      var pfield_cat_parent_processed = null;
      var $pfield_cat_parent = $('.block-tnv-tripplanner-filters-form .form-item-category-parent:not(.tp-processed)');
      if ($pfield_cat_parent.length > 0) {
        pfield_cat_parent_processed = $pfield_cat_parent.addClass('tp-processed').pSelect({
          default: urlCat,
          cascade: true,
          cascadeTarget: pfield_cat_child_processed,
          onChange: function (option) {
            // Catch Events category and redirect to calendar.
            if (option.data('filterValue') === 11 || option.data('filterValue') === '11') {
              window.location.replace('/calendar');
              return false;
            }
            $('form.views-exposed-form select[name=category]').val(option.data('filterValue'));
            // Submit form.
            Drupal.behaviors.tripPlannerFilters.filterSubmit();
          },
          onClear: function (plugin) {
            // Reset.
            $('form.views-exposed-form select[name=category]').val('All');
            // Submit form.
            Drupal.behaviors.tripPlannerFilters.filterSubmit();
          }
        });
      }

      // Set Parent if Child was set by URL.
      if (pfield_cat_child_processed && pfield_cat_child_processed.length && pfield_cat_child_processed.data('pSelect').getValue() && pfield_cat_parent_processed && pfield_cat_parent_processed.length && !pfield_cat_parent_processed.data('pSelect').getValue()) {
        pfield_cat_parent_processed.data('pSelect').initialSelect(pfield_cat_child_processed.data('pSelect').settings.optGroupId);
      }

      // Set Family Friendly filters.
      $(once('field', 'form#block-tnv-tripplanner-filters-form input[name=\'family_friendly\']')).on('change', function (e) {
        $('form.views-exposed-form input[name=\'attributes[family_friendly]\']').prop('checked', $(this).is(':checked'));
        // Submit form.
        Drupal.behaviors.tripPlannerFilters.filterSubmit();
      });

      // Set Live Music filters.
      $(once('field', 'form#block-tnv-tripplanner-filters-form input[name=\'live_music\']')).on('change', function (e) {
        $('form.views-exposed-form input[name=\'attributes[live_music]\']').prop('checked', $(this).is(':checked'));
        // Submit form.
        Drupal.behaviors.tripPlannerFilters.filterSubmit();
      });

      // Disable form submission on the fake filter form.
      $('#block-tnv-tripplanner-filters-form').submit(function (e) {e.preventDefault();});

      // Update current URL on ajax submission complete.
      $(document).ajaxComplete(function (event, xhr, settings) {
        if (settings.hasOwnProperty('extraData') && settings.extraData.hasOwnProperty('view_name') && settings.extraData.view_name === 'trip_planner') {
          Drupal.behaviors.tripPlannerFilters.setPageURL();
        }
      });

      // Support linking directly to cities and regions by title.
      if (Drupal.behaviors.tripPlannerFilters.pageInitialized === false) {
        if ($.QueryString.city) {
          $('.block-tnv-tripplanner-filters-form .form-item-location .pselect-item[data-filter-type="cities"]:contains("' + $.QueryString.city + '")').click();
        }
        else if ($.QueryString.region) {
          $('.block-tnv-tripplanner-filters-form .form-item-location .pselect-item[data-filter-type="regions"]:contains("' + $.QueryString.region + '")').click();
        }

        // Do final resubmission if psuedo values need to be updated.
        if (triggerResubmission) {
          Drupal.behaviors.tripPlannerFilters.filterSubmit();
        }
      }

      // Update dropdown with Drupal Settings Value if they match the url param.
      if (Drupal.behaviors.tripPlannerFilters.pageInitialized === false) {
        if ($.QueryString.location_city && typeof drupalSettings.location_city !== 'undefined') {
          $('[data-filter-controller~="location"] a.pselect-display-value').html(drupalSettings.location_city.title);
          delete drupalSettings.location_city;
        }
      }

      if (!once('ajaxerror', 'html').length) {
        return;
      }
      $(document).ajaxStop(function() {
        if ($('form#block-tnv-tripplanner-filters-form input[name=\'live_music\']').is(':checked') !==
          $('form.views-exposed-form input[name=\'attributes[live_music]\']').is(':checked') ||
          $('form#block-tnv-tripplanner-filters-form input[name=\'family_friendly\']').is(':checked') !==
          $('form.views-exposed-form input[name=\'attributes[family_friendly]\']').is(':checked')) {
          $('form.views-exposed-form input[name=\'attributes[live_music]\']').prop('checked', $('form#block-tnv-tripplanner-filters-form input[name=\'live_music\']').is(':checked'));
          $('form.views-exposed-form input[name=\'attributes[family_friendly]\']').prop('checked', $('form#block-tnv-tripplanner-filters-form input[name=\'family_friendly\']').is(':checked'));

          // Submit form.
          Drupal.behaviors.tripPlannerFilters.filterSubmit();
        }
      });
      // Mark that the filters have been initialized.
      Drupal.behaviors.tripPlannerFilters.pageInitialized = true;
    },
    filterSubmit: function () {
      // First clear history (since view blocks with exposed filters have their
      // form_state values overridden by the current url.
      if (history.replaceState) {
        window.history.pushState({}, '', this.getPageURL(false));
      }

      // Set session storage.
      if ($('#block-tnv-tripplanner-filters-form  #edit-family-friendly').prop('checked')) {
        sessionStorage.setItem('tpFamilyFriendly', 'checked');
      }
      else if (!$('#block-tnv-tripplanner-filters-form #edit-family-friendly').prop('checked')) {
        sessionStorage.removeItem('tpFamilyFriendly');
      }

      if ($('#block-tnv-tripplanner-filters-form  #edit-live-music').prop('checked')) {
        sessionStorage.setItem('tpLiveMusic', 'checked');
      }
      else if (!$('#block-tnv-tripplanner-filters-form #edit-live-music').prop('checked')) {
        sessionStorage.removeItem('tpLiveMusic');
      }

      // Submit form.
      $('form.views-exposed-form :input[name=filtered]').val('1');
      $('form.views-exposed-form input.form-submit').click();
      $('form.views-exposed-form :input[name=filtered]').val('0');
    },
    getPageTitle: function () {
      // @todo would be a good idea to update the title from filter criteria.
      return '';
    },
    getPageURL: function (withparams) {
      var url = [location.protocol, '//', location.host, location.pathname].join('');
      if (withparams) {
        url += '?' + $('form.views-exposed-form').serialize();
      }
      return url;
    },
    setCheckboxes: function () {
      // Set Family Friendly and Live Music attribute variables.
      var set = false;
      var getparams = new Proxy(new URLSearchParams(window.location.search), {
        get: (searchParams, prop) => searchParams.get(prop),
      });
      var urlAttrFF = (getparams['attributes[family_friendly]'] === 'family_friendly' || getparams['attributes[family_friendly]'] === '1');
      var urlAttrLM = (getparams['attributes[live_music]'] === 'live_music' || getparams['attributes[live_music]'] === '1');

      // Select the checkboxes if they were previously set with session storage.
      // Family Friendly attribute filter checkbox.
      if (urlAttrFF) {
        $('#edit-family-friendly').prop('checked', true);
        $('*[data-drupal-selector="edit-attributes-family-friendly"]').prop('checked', true);
        set = true;
      }

      // Live Music attribute filter checkbox.
      if (urlAttrLM) {
        $('#edit-live-music').prop('checked', true);
        $('*[data-drupal-selector=\'edit-attributes-live-music\']').prop('checked', true);
        set = true;
      }

      if (set) {
        $('#edit-submit-trip-planner').click();
      }
    },
    setPageURL: function () {
      if (history.replaceState) {
        window.history.replaceState({}, this.getPageTitle(), this.getPageURL(true));
      }
    },
    pageInitialized: false
  };
})(jQuery, Drupal, drupalSettings, once); // eslint-disable-line no-undef
